import React, { useState } from "react";
import _ from "lodash";

import type { NormalisedProduct } from "@app/scripts/types";
import { sortedVariants, sortVariants, stripColourFromVariantTitle } from "@app/scripts/utils";
import { useLocaleContext } from "@app/scripts/react-providers/locales";

type Props = {
  variants: NormalisedProduct["variants"];
  handleChangeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultTitle?: string;
  selectedId?: string | number;
  lineItemKey?: string | number;
};

export const ProductSizeSelect: React.FC<Props> = ({
  variants,
  handleChangeVariant,
  defaultTitle = "Select size",
  selectedId,
}) => {
  const { product: productLocale } = useLocaleContext();
  const [defaultVisible, setDefaultVisible] = useState(true);

  const changeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void = (e) => {
    if (e.target.value !== "__default") {
      setDefaultVisible(false);
      handleChangeVariant(e);
    }
  };

  // Sorting variants to display correct order when nested
  const sortedVariants = sortVariants(variants)

  return sortedVariants && sortedVariants.length > 1 ? (
    <div className="product__variant-picker _field _field__select">
      <select className="select__select" name="Size" aria-label={productLocale?.select_size || "Select size"} onChange={changeVariant} defaultValue={selectedId}>
        {!selectedId && defaultVisible && <option value="__default">{defaultTitle}</option>}
        {sortedVariants?.map((variant) => (
          <option key={variant.id} value={variant.id} disabled={variant.available === false || variant.currentlyNotInStock === true}>
            {stripColourFromVariantTitle(variant.title)}
            {(variant.available === false || variant.currentlyNotInStock === true) &&
              ` — ${productLocale?.sold_out?.out_of_stock || "Out of stock"}`}
          </option>
        ))}
      </select>
    </div>
  ) : null;
};
